export default class NewsletterSignupRequestData {
  public email: string

  public constructor (
    email: string) {
    this.email = email
  }
}
